/* Plantilla "Kit de Bombeo Solar": galería, selector de kit/variante y enlaces de WhatsApp.
   Sin dependencias; la página se ve completa sin este script (mejora progresiva).
   Compatible con el editor de temas: se reinicia con shopify:section:load y reacciona a shopify:block:select. */
(function () {
  'use strict';
  if (window.__bsPdp) { window.__bsPdp.init(); return; }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var state = null; /* { variants, current, title } de la sección de compra activa */
  var api = {};

  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function starts(v, m) { return !!m && v.option1.toLowerCase().indexOf(m.toLowerCase()) === 0; }
  function label(v) { return v && v.title && v.title !== 'Default Title' ? ' (' + v.title + ')' : ''; }

  function updateWa() {
    if (!state) return;
    $all('[data-bs-wa]').forEach(function (a) {
      var msg = (a.dataset.msg || '').split('{producto}').join(state.title).split('{variante}').join(label(state.current));
      a.href = 'https://wa.me/' + (a.dataset.number || '').replace(/\D/g, '') + '?text=' + encodeURIComponent(msg);
    });
  }
  api.updateWa = updateWa;

  function initBuy(root) {
    if (!root || root.dataset.bsReady) return;
    root.dataset.bsReady = '1';
    var data = {};
    try { data = JSON.parse(root.querySelector('[data-bs-json]').textContent); } catch (e) { return; }
    var variants = data.variants || [];
    var st = state = { variants: variants, title: data.title, current: variants.filter(function (v) { return v.id === data.current; })[0] || variants[0] };
    if (!st.current) return;

    /* variante por combinación exacta de opciones (Tipo + Potencia) */
    function variantOf(o1, o2) { return variants.filter(function (v) { return v.option1 === o1 && (o2 == null || v.option2 === o2); })[0]; }
    function firstOf(o1) { var l = variants.filter(function (v) { return v.option1 === o1; }); return l.filter(function (v) { return v.available; })[0] || l[0]; }
    function fill(t, label) { return (t || '').split('{potencia}').join(label || '').replace(/\s+/g, ' ').trim(); }

    /* ---------- Galería ---------- */
    var gal = root.querySelector('[data-bs-gal]');
    var goTo = function () {};
    if (gal) {
      var track = gal.querySelector('[data-bs-track]');
      var thumbs = $all('[data-bs-thumb]', gal);
      var active = 0, raf = 0;
      var mark = function (i) {
        active = i;
        thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
        var t = thumbs[i];
        if (t && t.parentNode.scrollWidth > t.parentNode.clientWidth) {
          t.parentNode.scrollTo({ left: t.offsetLeft - (t.parentNode.clientWidth - t.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
        }
      };
      goTo = function (i) {
        if (!track || i < 0) return;
        track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
        mark(i);
      };
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
      if (track) {
        track.addEventListener('scroll', function () {
          if (raf) return;
          raf = requestAnimationFrame(function () {
            raf = 0;
            var i = Math.round(track.scrollLeft / (track.clientWidth || 1));
            if (i !== active) mark(i);
          });
        }, { passive: true });
      }
    }

    /* ---------- Selector (Tipo + Potencia) ---------- */
    var kits = $all('[data-bs-kit]', root);
    var powers = $all('[data-bs-power]', root);
    var details = $all('[data-bs-detail]', root);
    var idInput = root.querySelector('[data-bs-id]');
    var buyBtn = root.querySelector('[data-bs-buy-btn]');
    function setText(sel, txt) { $all(sel, root).forEach(function (e) { e.textContent = txt; }); }

    function render() {
      var cur = st.current, kitCard = null, powerCard = null;
      kits.forEach(function (k) {
        var on = k.dataset.opt1 === cur.option1;
        k.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) kitCard = k;
      });
      powers.forEach(function (p) {
        var v = variantOf(cur.option1, p.dataset.opt2);
        var on = p.dataset.opt2 === cur.option2;
        p.setAttribute('aria-pressed', on ? 'true' : 'false');
        p.disabled = !v || !v.available;
        var pr = p.querySelector('[data-bs-power-price]');
        if (pr) pr.textContent = !v ? 'No disponible' : (v.available ? v.priceText : 'Agotado');
        if (on) powerCard = p;
      });
      details.forEach(function (d) { d.hidden = !kitCard || d.dataset.bsDetail !== kitCard.dataset.i; });

      var plabel = powerCard ? powerCard.dataset.label : (cur.option2 || '');
      setText('[data-bs-price]', cur.priceText);
      $all('[data-bs-was]', root).forEach(function (e) { e.hidden = !cur.wasText; e.textContent = cur.wasText || ''; });
      setText('[data-bs-note]', fill(kitCard && kitCard.dataset.note, plabel));
      setText('[data-bs-short]', fill(kitCard && kitCard.dataset.short, plabel) || data.title);
      if (idInput) idInput.value = cur.id;
      if (buyBtn) {
        buyBtn.disabled = !cur.available;
        buyBtn.textContent = cur.available ? buyBtn.dataset.label : buyBtn.dataset.soldout;
      }
      updateWa();
      if (history.replaceState && variants.length > 1 && !root.hasAttribute('data-bs-editor')) {
        try { var u = new URL(location.href); u.searchParams.set('variant', cur.id); history.replaceState(null, '', u); } catch (e) {}
      }
    }

    function select(v, fromUser) {
      if (!v) return;
      st.current = v;
      render();
      if (fromUser && typeof v.media === 'number' && v.media >= 0) goTo(v.media);
    }

    kits.forEach(function (k) {
      k.addEventListener('click', function () {
        var v = variantOf(k.dataset.opt1, st.current.option2);
        if (!v || !v.available) v = firstOf(k.dataset.opt1);
        select(v, true);
      });
    });
    powers.forEach(function (p) {
      p.addEventListener('click', function () {
        var v = variantOf(st.current.option1, p.dataset.opt2);
        if (v && v.available) select(v, true);
      });
    });

    /* Editor de temas: al elegir un bloque se muestra en la vista previa */
    root.addEventListener('shopify:block:select', function (e) {
      var el = e.target;
      if (el.matches && el.matches('[data-bs-gal] .bs-gal__slide')) goTo($all('.bs-gal__slide', root).indexOf(el));
      if (el.matches && (el.matches('[data-bs-kit]') || el.matches('[data-bs-power]'))) el.click();
    });

    render();
  }

  /* Texto alternativo propio para la imagen del celular (el <picture> tiene un solo alt) */
  function setAlts() {
    var mq = window.matchMedia && window.matchMedia('(max-width: 749px)');
    $all('img[data-alt-m]').forEach(function (img) {
      if (!img.dataset.altD) img.dataset.altD = img.getAttribute('alt') || '';
      img.setAttribute('alt', mq && mq.matches ? img.dataset.altM : img.dataset.altD);
    });
  }

  /* Fotos de proyectos: puntos y flechas del carrusel */
  function initPh(root) {
    if (root.dataset.bsReady) return;
    root.dataset.bsReady = '1';
    var track = root.querySelector('[data-bs-ph-track]');
    var items = $all('.bs-gal3__item', root);
    var dots = root.querySelector('[data-bs-ph-dots]');
    var prev = root.querySelector('[data-bs-ph-prev]');
    var next = root.querySelector('[data-bs-ph-next]');
    if (!track || items.length < 2) return;
    var btns = items.map(function (it, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.setAttribute('aria-label', 'Ir a la foto ' + (i + 1) + ' de ' + items.length);
      b.addEventListener('click', function () { goTo(i); });
      dots.appendChild(b); return b;
    });
    function left(i) { return items[i].offsetLeft - items[0].offsetLeft; }
    function goTo(i) { track.scrollTo({ left: left(Math.max(0, Math.min(items.length - 1, i))), behavior: reduce ? 'auto' : 'smooth' }); }
    function current() {
      var best = 0, d = 1e9;
      items.forEach(function (it, i) { var x = Math.abs(left(i) - track.scrollLeft); if (x < d) { d = x; best = i; } });
      return best;
    }
    function mark() {
      var i = current();
      btns.forEach(function (b, n) { b.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    var raf = 0;
    track.addEventListener('scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; mark(); }); }, { passive: true });
    if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
    if (next) next.addEventListener('click', function () { goTo(current() + 1); });
    root.addEventListener('shopify:block:select', function (e) { var i = items.indexOf(e.target); if (i >= 0) goTo(i); });
    window.addEventListener('resize', mark);
    mark();
  }

  api.init = function () { setAlts(); $all('[data-bs-buy]').forEach(initBuy); $all('[data-bs-ph]').forEach(initPh); updateWa(); };
  /* Enlaces "elige la opción X": suben al selector (el ancla lo hace) y eligen esa opción */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-bs-pick]');
    if (!a) return;
    var card = document.querySelectorAll('[data-bs-kit]')[parseInt(a.getAttribute('data-bs-pick'), 10)];
    if (card && !card.disabled) card.click();
  });

  window.__bsPdp = api;

  /* El editor vuelve a dibujar la sección al cambiar un ajuste */
  document.addEventListener('shopify:section:load', function () { api.init(); });
  document.addEventListener('shopify:section:unload', function () { state = null; api.init(); });

  api.init();
})();
